/* tslint:disable */
/* eslint-disable */
/**
 * Micro Interactions B Service
 * API for micro-interactions
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
  ApiActionButton,
  ApiActionButtonFromJSON,
  ApiActionButtonFromJSONTyped,
  ApiActionButtonToJSON,
} from './ApiActionButton';
import { ApiAvatar, ApiAvatarFromJSON, ApiAvatarFromJSONTyped, ApiAvatarToJSON } from './ApiAvatar';
import {
  ApiBackButton,
  ApiBackButtonFromJSON,
  ApiBackButtonFromJSONTyped,
  ApiBackButtonToJSON,
} from './ApiBackButton';
import {
  ApiDismiss,
  ApiDismissFromJSON,
  ApiDismissFromJSONTyped,
  ApiDismissToJSON,
} from './ApiDismiss';
import { ApiEvent, ApiEventFromJSON, ApiEventFromJSONTyped, ApiEventToJSON } from './ApiEvent';
import {
  ApiFeedback,
  ApiFeedbackFromJSON,
  ApiFeedbackFromJSONTyped,
  ApiFeedbackToJSON,
} from './ApiFeedback';
import { ApiFooter, ApiFooterFromJSON, ApiFooterFromJSONTyped, ApiFooterToJSON } from './ApiFooter';
import {
  ApiSaveState,
  ApiSaveStateFromJSON,
  ApiSaveStateFromJSONTyped,
  ApiSaveStateToJSON,
} from './ApiSaveState';
import {
  ApiViewPetProfileIngress,
  ApiViewPetProfileIngressFromJSON,
  ApiViewPetProfileIngressFromJSONTyped,
  ApiViewPetProfileIngressToJSON,
} from './ApiViewPetProfileIngress';

/**
 *
 * @export
 * @interface ApiUpdatePetAttributeDate
 */
export interface ApiUpdatePetAttributeDate {
  /**
   *
   * @type {number}
   * @memberof ApiUpdatePetAttributeDate
   */
  id: number;
  /**
   *
   * @type {ApiAvatar}
   * @memberof ApiUpdatePetAttributeDate
   */
  avatar?: ApiAvatar;
  /**
   *
   * @type {ApiBackButton}
   * @memberof ApiUpdatePetAttributeDate
   */
  backButton?: ApiBackButton;
  /**
   *
   * @type {ApiDismiss}
   * @memberof ApiUpdatePetAttributeDate
   */
  dismiss?: ApiDismiss;
  /**
   *
   * @type {string}
   * @memberof ApiUpdatePetAttributeDate
   */
  heading: string;
  /**
   *
   * @type {string}
   * @memberof ApiUpdatePetAttributeDate
   */
  subHeading?: string;
  /**
   *
   * @type {string}
   * @memberof ApiUpdatePetAttributeDate
   */
  petProfileAttribute: ApiUpdatePetAttributeDatePetProfileAttributeEnum;
  /**
   *
   * @type {Array<ApiActionButton>}
   * @memberof ApiUpdatePetAttributeDate
   */
  actions: Array<ApiActionButton>;
  /**
   *
   * @type {ApiViewPetProfileIngress}
   * @memberof ApiUpdatePetAttributeDate
   */
  viewPetProfileIngress?: ApiViewPetProfileIngress;
  /**
   *
   * @type {ApiFeedback}
   * @memberof ApiUpdatePetAttributeDate
   */
  feedback?: ApiFeedback;
  /**
   *
   * @type {ApiFooter}
   * @memberof ApiUpdatePetAttributeDate
   */
  footer?: ApiFooter;
  /**
   *
   * @type {ApiEvent}
   * @memberof ApiUpdatePetAttributeDate
   */
  event: ApiEvent;
  /**
   *
   * @type {ApiSaveState}
   * @memberof ApiUpdatePetAttributeDate
   */
  saveState?: ApiSaveState;
}

/**
 * @export
 */
export const ApiUpdatePetAttributeDatePetProfileAttributeEnum = {
  Birthday: 'birthday',
  AdoptionDate: 'adoptionDate',
} as const;
export type ApiUpdatePetAttributeDatePetProfileAttributeEnum = typeof ApiUpdatePetAttributeDatePetProfileAttributeEnum[keyof typeof ApiUpdatePetAttributeDatePetProfileAttributeEnum];

export function ApiUpdatePetAttributeDateFromJSON(json: any): ApiUpdatePetAttributeDate {
  return ApiUpdatePetAttributeDateFromJSONTyped(json, false);
}

export function ApiUpdatePetAttributeDateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ApiUpdatePetAttributeDate {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: json['id'],
    avatar: !exists(json, 'avatar') ? undefined : ApiAvatarFromJSON(json['avatar']),
    backButton: !exists(json, 'backButton') ? undefined : ApiBackButtonFromJSON(json['backButton']),
    dismiss: !exists(json, 'dismiss') ? undefined : ApiDismissFromJSON(json['dismiss']),
    heading: json['heading'],
    subHeading: !exists(json, 'subHeading') ? undefined : json['subHeading'],
    petProfileAttribute: json['petProfileAttribute'],
    actions: (json['actions'] as Array<any>).map(ApiActionButtonFromJSON),
    viewPetProfileIngress: !exists(json, 'viewPetProfileIngress')
      ? undefined
      : ApiViewPetProfileIngressFromJSON(json['viewPetProfileIngress']),
    feedback: !exists(json, 'feedback') ? undefined : ApiFeedbackFromJSON(json['feedback']),
    footer: !exists(json, 'footer') ? undefined : ApiFooterFromJSON(json['footer']),
    event: ApiEventFromJSON(json['event']),
    saveState: !exists(json, 'saveState') ? undefined : ApiSaveStateFromJSON(json['saveState']),
  };
}

export function ApiUpdatePetAttributeDateToJSON(value?: ApiUpdatePetAttributeDate | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    avatar: ApiAvatarToJSON(value.avatar),
    backButton: ApiBackButtonToJSON(value.backButton),
    dismiss: ApiDismissToJSON(value.dismiss),
    heading: value.heading,
    subHeading: value.subHeading,
    petProfileAttribute: value.petProfileAttribute,
    actions: (value.actions as Array<any>).map(ApiActionButtonToJSON),
    viewPetProfileIngress: ApiViewPetProfileIngressToJSON(value.viewPetProfileIngress),
    feedback: ApiFeedbackToJSON(value.feedback),
    footer: ApiFooterToJSON(value.footer),
    event: ApiEventToJSON(value.event),
    saveState: ApiSaveStateToJSON(value.saveState),
  };
}
